export default __webpack_public_path__ + "static/media/meeting.ec9a7c23.jpg";